import React from 'react';
import { Balance } from './components/Balance';
import { UserAvatar } from './components/UserAvatar';
import { Container } from './styles';
import { ViewType } from '../../types';

export interface Props {
  openSideMenu: () => void;
  view: ViewType;
  openDeposit: () => void;
  openWithdraw: () => void;
  onAccountsClick: () => void;
  is2FADisabled?: boolean;
}

export const UserBlock: React.FC<Props> = ({
  view,
  openSideMenu,
  openDeposit,
  openWithdraw,
  onAccountsClick,
  is2FADisabled,
}) => (
  <Container data-testid="user-menu">
    <Balance
      view={view}
      openDeposit={openDeposit}
      openWithdraw={openWithdraw}
      onAccountsClick={onAccountsClick}
    />
    <UserAvatar openSideMenu={openSideMenu} menuView={view} warning={is2FADisabled} />
  </Container>
);
